var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinancecoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106684",
    "data-name": "Group 106684",
    transform: "translate(3841 3948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49312",
    "data-name": "Path 49312",
    d: "M22,0A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z",
    transform: "translate(-3841 -3948)",
    fill: "#f0b90b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_106031",
    "data-name": "Group 106031",
    transform: "translate(-1.179 -0.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49313",
    "data-name": "Path 49313",
    d: "M525.423,733.844l.016,5.7,4.847,2.852v3.34l-7.684-4.507v-9.058l2.821,1.668Zm0-5.7v3.324l-2.823-1.67V726.47l2.823-1.67,2.837,1.67-2.837,1.67Zm6.887-1.67,2.823-1.67,2.836,1.67-2.836,1.67-2.823-1.67Z",
    transform: "translate(-4353.421 -4659.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49314",
    "data-name": "Path 49314",
    d: "M803.9,738.366v-3.34l2.823,1.67v3.324l-2.823-1.654Zm4.847,5.231,2.823,1.67,2.837-1.67v3.324l-2.837,1.67-2.823-1.67V743.6Zm9.708-17.127,2.823-1.67,2.837,1.67v3.324l-2.837,1.67V728.14l-2.823-1.67Zm2.823,13.079.016-5.7,2.823-1.67v9.058l-7.684,4.506V742.4l4.845-2.851Z",
    transform: "translate(-4629.859 -4659.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49315",
    "data-name": "Path 49315",
    d: "M1531.623,1319.74l-2.823,1.654v-3.324l2.823-1.67Z",
    transform: "translate(-5342.229 -5240.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49316",
    "data-name": "Path 49316",
    d: "M819.253,405.125l.016,3.34-4.861,2.852v5.718l-2.823,1.654-2.823-1.654v-5.718l-4.861-2.852v-3.34l2.835-1.67,4.831,2.866,4.861-2.866,2.837,1.67Zm-15.354-5.7,7.67-4.522,7.684,4.522-2.823,1.67-4.861-2.866-4.847,2.866-2.823-1.67Z",
    transform: "translate(-4629.859 -4335.208)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinancecoin);
export default __webpack_public_path__ + "static/media/binancecoin.f66b785a5360e8829ccffef3852130c7.svg";
export { ForwardRef as ReactComponent };